export default __webpack_public_path__ + "images/AW.7e578b9.png";